const f = {
  color: {
    confirm: {
      color: "#304ddbff",
      border: "#304ddbff"
    },
    background: {
      default: "#ffffffff",
      hover: "#f1f3f5ff"
    }
  }
};
export {
  f as inputCopy
};
